import React, { createContext, useMemo, useState, useEffect } from "react";
import propTypes from "prop-types";
import i18n from "../i18n/i18n";
import { resolveLanguage } from "../i18n/languageUtils";

const ConfigContext = createContext({
  config: null,
  configError: null,
  userLang: "en",
});

const ConfigProvider = (props) => {
  const [config, setConfig] = useState(null);
  const [configError, setConfigError] = useState(null);
  const [configReady, setConfigReady] = useState(false);
  const [userLang] = useState(() => i18n.language || resolveLanguage());

  useEffect(() => {
    if (!configReady) {
      fetch("/ciam/v1/static/config.json")
        .then((response) => response.json())
        .then((data) => {
          data.userLang = userLang; // Add userLang to config for global access
          setConfig(data);
          setConfigReady(true);
        })
        .catch((error) => {
          setConfigError(error);
        });
    }
  }, [configReady]);

  const memoedConfig = useMemo(
    () => ({
      config,
      configError,
      configReady,
      userLang,
    }),
    [configReady, userLang]
  );

  return <ConfigContext.Provider value={memoedConfig}>{props.children}</ConfigContext.Provider>;
};

ConfigProvider.propTypes = {
  children: propTypes.node,
};

export default ConfigProvider;
export const useConfig = () => React.useContext(ConfigContext);
